export const GAME_CONFIG = {
  // Bonus additifs disponibles (ajoutent directement des coins par clic)
  additiveBonus: [
    { 
      id: 'bonus_1',
      value: 1,
      basePrice: 100,
      maxOwned: 5,
      description: "+1 coin par clic",
      color: "blue"
    },
    { 
      id: 'bonus_2',
      value: 2,
      basePrice: 250,
      maxOwned: 4,
      description: "+2 coins par clic",
      color: "green"
    },
    { 
      id: 'bonus_3',
      value: 3,
      basePrice: 500,
      maxOwned: 3,
      description: "+3 coins par clic",
      color: "yellow"
    },
    { 
      id: 'bonus_5',
      value: 5,
      basePrice: 1000,
      maxOwned: 2,
      description: "+5 coins par clic",
      color: "orange"
    },
    { 
      id: 'bonus_10',
      value: 10,
      basePrice: 2500,
      maxOwned: 1,
      description: "+10 coins par clic",
      color: "red"
    }
  ],

  // Multiplicateurs (multiplient le total après les bonus additifs)
  multipliers: [
    {
      id: 'multiplier_2x',
      value: 2,
      basePrice: 5000,
      maxOwned: 1,
      description: "Double tous vos gains",
      color: "purple",
      unlockLevel: 1,
      type: 2
    }
  ],

  // Auto-clickers
  autoClickers: [
    { 
      type: 1, 
      basePrice: 1000, 
      maxOwned: 3,
      description: "Clique automatiquement une fois par seconde",
      color: "blue"
    },
    { 
      type: 2, 
      basePrice: 2500, 
      maxOwned: 2,
      description: "Clique automatiquement deux fois par seconde",
      color: "indigo"
    },
    { 
      type: 5, 
      basePrice: 5000, 
      maxOwned: 1,
      description: "Clique automatiquement cinq fois par seconde",
      color: "violet"
    }
  ],

  // Boosts temporaires
  temporaryBoosts: [
    {
      id: 'double_coins',
      name: 'Double Coins',
      description: 'Double les gains de coins pendant 5 minutes',
      basePrice: 1000,
      duration: 300000, // 5 minutes en millisecondes
      effect: 2
    },
    {
      id: 'triple_coins',
      name: 'Triple Coins',
      description: 'Triple les gains de coins pendant 2 minutes',
      basePrice: 2000,
      duration: 120000, // 2 minutes en millisecondes
      effect: 3
    },
    {
      id: 'super_critical',
      name: 'Super Critique',
      description: 'Augmente les chances de coups critiques pendant 3 minutes',
      basePrice: 1500,
      duration: 180000, // 3 minutes en millisecondes
      effect: 2
    }
  ],

  // Améliorations passives
  passiveUpgrades: [
    {
      id: 'click_power',
      name: 'Puissance de Clic',
      description: 'Augmente la puissance de base des clics',
      basePrice: 500,
      maxLevel: 10,
      effect: 0.1 // +10% par niveau
    },
    {
      id: 'critical_chance',
      name: 'Chance Critique',
      description: 'Augmente les chances de coups critiques',
      basePrice: 1000,
      maxLevel: 5,
      effect: 0.05 // +5% par niveau
    },
    {
      id: 'mining_efficiency',
      name: 'Efficacité de Minage',
      description: 'Réduit le nombre de clics nécessaires pour miner',
      basePrice: 2000,
      maxLevel: 3,
      effect: 0.2 // -20% par niveau
    }
  ],

  // Paramètres de progression
  priceIncreaseFactor: 1.5,     // Le prix augmente de 50% à chaque achat
  baseClickValue: 1,            // Valeur de base d'un clic
  autoClickInterval: 1000,      // Intervalle entre les clics automatiques (en ms)
  criticalClickChance: 0.05,    // 5% de chance de coup critique
  criticalClickMultiplier: 2,   // Les coups critiques font x2 dégâts
  levelUpThreshold: 1000,       // XP nécessaire pour le niveau 1
  levelUpMultiplier: 1.2,       // +20% de puissance par niveau
  maxLevel: 100                 // Niveau maximum
};